import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[onlyInteger]"
})
export class OnlyIntegerDirective {

  constructor(private element: ElementRef) {
  }

  @HostListener("keydown", ["$event"]) onKeyDown(event) {
    const e = event as KeyboardEvent;
    if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "-", "Left", "ArrowLeft", "Right", "ArrowRight"].indexOf(e.key) === -1) {
      e.preventDefault();
    } else {
      if (e.key === "-") {
        if (event.target.value.includes("-") || event.target.value === "0") {
          e.preventDefault();
        } else {
          e.preventDefault();
          event.target.value = "-" + event.target.value;
        }
      }
    }
  }

  @HostListener("blur", ["$event"]) onBlur(event) {
    event.target.value = event.target.value.replace(/[^0-9\-]+/g, "");
  }
}
